import { useStore } from 'effector-react';
import { $templateId } from '@stores/dataStores';
import { type templateConfig, getTemplateConfig } from '@utils/templateConfig';

function useTemplateFeature<T extends keyof typeof templateConfig>(key: T) {
  const templateId = useStore($templateId);
  return getTemplateConfig(templateId)(key);
}

export default useTemplateFeature;
